var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWinner(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 13,
    viewBox: "0 0 16 13",
    fill: "#311B77",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.6072 2.56307L13.4332 0.38916L5.55722 8.54133L2.56368 5.60655L0.389771 7.99786L5.55722 12.8892L15.6072 2.56307Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWinner);
export default __webpack_public_path__ + "static/media/winner.cf647f765566b710cb75d6b4eefab492.svg";
export { ForwardRef as ReactComponent };